export default __webpack_public_path__ + "static/media/ASR_URUN_HIZMET_ADET.f12d3900.xlsx";